(() => {
  const dialog = document.querySelector('[data-cookie-preferences]');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const form = dialog.querySelector('[data-cookie-form]');
  const fields = dialog.querySelector('[data-cookie-fields]');
  const status = dialog.querySelector('[data-cookie-status]');
  const retry = dialog.querySelector('[data-cookie-retry]');
  const buttons = [...dialog.querySelectorAll('[data-cookie-save], [data-cookie-accept], [data-cookie-decline]')];
  const confirmation = document.querySelector('[data-cookie-confirmation]');
  const categories = ['analytics', 'marketing', 'preferences'];
  let api;
  let apiPromise;
  let opener;
  let generation = 0;
  let saving = false;
  let initialSharing = false;
  const hasPrivacyControl = () => navigator.globalPrivacyControl === true;
  const input = name => form.elements.namedItem(name);
  const busy = value => {
    fields.disabled = value;
    buttons.forEach(button => { button.disabled = value; });
    dialog.setAttribute('aria-busy', String(value));
  };
  const loadApi = () => {
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const started = Date.now();
      let completed = false;
      const finish = (error, result) => {
        if (completed) return;
        completed = true;
        clearTimeout(timeout);
        error ? reject(error) : resolve(result);
      };
      const timeout = setTimeout(() => finish(new Error('Privacy settings unavailable')), 15000);
      const load = () => {
        const shopify = window.Shopify;
        const current = shopify && shopify.customerPrivacy;
        if (current && typeof current.currentVisitorConsent === 'function' && typeof current.setTrackingConsent === 'function') {
          finish(null, current);
        } else if (shopify && typeof shopify.loadFeatures === 'function') {
          shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
            const loaded = window.Shopify && window.Shopify.customerPrivacy;
            if (error || !loaded || typeof loaded.currentVisitorConsent !== 'function' || typeof loaded.setTrackingConsent !== 'function') finish(error || new Error('Privacy settings unavailable'));
            else finish(null, loaded);
          });
        } else if (Date.now() - started < 14500) setTimeout(load, 150);
      };
      load();
    }).catch(error => { apiPromise = null; throw error; });
    return apiPromise;
  };
  const initialize = async () => {
    const currentGeneration = ++generation;
    busy(true);
    retry.hidden = true;
    status.textContent = dialog.dataset.loading;
    try {
      api = await loadApi();
      if (currentGeneration !== generation || !dialog.open) return;
      const consent = api.currentVisitorConsent();
      categories.forEach(category => { input(category).checked = consent[category] === 'yes'; });
      input('sharing_opt_out').checked = consent.sale_of_data === 'no' || hasPrivacyControl();
      initialSharing = input('sharing_opt_out').checked;
      input('sharing_opt_out').disabled = hasPrivacyControl();
      dialog.querySelector('[data-cookie-gpc]').hidden = !hasPrivacyControl();
      status.textContent = '';
      busy(saving);
    } catch (error) {
      if (currentGeneration !== generation || !dialog.open) return;
      dialog.setAttribute('aria-busy', 'false');
      status.textContent = dialog.dataset.error;
      retry.hidden = false;
    }
  };
  const open = trigger => {
    if (dialog.open) return;
    opener = trigger;
    if (confirmation) confirmation.textContent = '';
    dialog.showModal();
    initialize();
  };
  const save = mode => {
    if (!api || saving || fields.disabled) return;
    const saveGeneration = generation;
    if (mode === 'accept' || mode === 'decline') categories.forEach(category => { input(category).checked = mode === 'accept'; });
    const consent = Object.fromEntries(categories.map(category => [category, input(category).checked]));
    const sharingOptOut = input('sharing_opt_out').checked || hasPrivacyControl();
    if (sharingOptOut || sharingOptOut !== initialSharing) consent.sale_of_data = !sharingOptOut;
    saving = true;
    busy(true);
    retry.hidden = true;
    status.textContent = dialog.dataset.saving;
    let completed = false;
    const finish = error => {
      if (completed) return;
      completed = true;
      clearTimeout(timeout);
      saving = false;
      if (error) {
        if (saveGeneration !== generation) {
          if (dialog.open) initialize();
          return;
        }
        status.textContent = dialog.dataset.saveError;
        busy(false);
        return;
      }
      if (confirmation) confirmation.textContent = dialog.dataset.saved;
      if (saveGeneration === generation) dialog.close();
      else if (dialog.open) initialize();
    };
    const timeout = setTimeout(() => finish(new Error('Privacy settings unavailable')), 15000);
    try { api.setTrackingConsent(consent, (error, result) => finish(error || (result && result.error))); }
    catch (error) { finish(error); }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cookie-preferences-open]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });
  dialog.querySelector('[data-cookie-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    generation += 1;
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  retry.addEventListener('click', initialize);
  form.addEventListener('submit', event => { event.preventDefault(); save('save'); });
  dialog.querySelector('[data-cookie-accept]').addEventListener('click', () => save('accept'));
  dialog.querySelector('[data-cookie-decline]').addEventListener('click', () => save('decline'));
})();
